import { z } from 'zod';
export const resetUserPasswordRequestParamsSchema = z.object({
    accountId: z.string(),
});
export const resetUserPasswordResponseSchema = z.void();
